// eslint-disable-next-line import/prefer-default-export

import glamorous from 'glamorous';

// ::
export const TrainingImage = glamorous.div('g72-training fs28-sm mt12-sm', () => ({
    width: "226px",
    height: "113px",
}));
TrainingImage.displayName = 'TrainingImage';

// ::
export const UserWrapper = glamorous.div('ncss-base', () => ({}));
UserWrapper.displayName = 'UserWrapper';



// WEBPACK FOOTER //
// ./src/containers/ErrorPage/ErrorPage.style.js